import type { MediaDto } from '@gr/core/content/media/dto';
import { ACCEPTED_UPLOAD_EXTENSIONS } from '@gr/core/content/media/formats';

export enum UploadState {
  Uploading = 'uploading',
  Done = 'done',
  Duplicate = 'duplicate',
  Failed = 'failed',
}

/** Файл в очереди загрузки (MED-UC-1): свой прогресс и свой результат. */
export interface UploadItem {
  id: string;
  name: string;
  progress: number;
  state: UploadState;
  error: string | null;
  media: MediaDto | null;
}

/** Что принимает поле выбора файлов: известные расширения и любые картинки и видео. */
export const UPLOAD_ACCEPT = [...ACCEPTED_UPLOAD_EXTENSIONS, 'image/*', 'video/*'].join(',');

/** Доля загруженного; браузер может не знать общий размер — тогда 0. */
export function uploadProgress(loaded: number, total: number | null | undefined): number {
  return total ? Math.min(1, loaded / total) : 0;
}
